import { FollowupModel, FollowupStatus } from '@/models/followup.model'
import { api } from '@/services/api'

export type CreateFollowupResponse = {
  followup: FollowupModel
}

export async function createFollowup(params: Omit<FollowupModel, 'id' | 'createdAt' | 'updatedAt'>) {
  const response = await api.post<CreateFollowupResponse>('/followups', params)
  return response.data
}

export type UpdateFollowupResponse = {
  followup: FollowupModel
}

export async function updateFollowup(followupId: string, dataToUpdate: Partial<FollowupModel>) {
  const response = await api.put<UpdateFollowupResponse>('/followups', { followupId, dataToUpdate })
  return response.data
}

export async function deleteFollowup(followupId: string) {
  await api.delete(`/followups/${followupId}`)
}

export type FetchFollowupsByOperatorParams = {
  companyId: string
  ownerId: string
  operatorId?: string
  page?: number
  limit?: number
  status?: FollowupStatus | ''
  search?: string
  sort?: 'newest' | 'oldest'
  startDate?: string
  endDate?: string
}

export type FetchFollowupsByOperatorResponse = {
  followups: FollowupModel[]
  total: number
  page: number
  totalPages: number
}

export async function fetchFollowupsByOperator(params: FetchFollowupsByOperatorParams) {
  const response = await api.get<FetchFollowupsByOperatorResponse>('/followups/by-operator', { params })
  return response.data
}

export type FetchFollowupsByChatParams = {
  ownerId: string
  chatId: string
  statuses: FollowupStatus[]
}

export type FetchFollowupsByChatResponse = {
  followups: FollowupModel[]
}

export async function fetchFollowupsByChat(params: FetchFollowupsByChatParams) {
  const response = await api.get<FetchFollowupsByChatResponse>('/followups/by-chat', { params })
  return response.data
}
